export const SET_PENDING = "state/dealerships/SET_PENDING";
export const SET_TOUCHED = "state/dealerships/SET_TOUCHED";
export const SET_DEALERSHIPS = "state/dealerships/SET_DEALERSHIPS";
export const FORGET_DEALERSHIPS = "state/dealerships/FORGET_DEALERSHIPS";
